import { connect } from 'react-redux';
import { 
	addPhotoToFavoritesAction,
	openModalAction
} from '../flickr-redux/actions';
import ImageBox from './ImageBox';

const mapStateToProps = (state) => {
	return {
		favorites: state.photos.favorites
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		onAddToFavorites: (photo) => {
			dispatch(addPhotoToFavoritesAction(photo));
		},
		dispatchOpenModal: (photoUrl, photoTitle, modalComponent) => {
			dispatch(openModalAction(photoUrl, photoTitle, modalComponent));
		}
	}
}

const ImageBoxContainer = connect(mapStateToProps, mapDispatchToProps)(ImageBox);
export default ImageBoxContainer;



/** WEBPACK FOOTER **
 ** ./src/image-display/ImageBoxContainer.js
 **/